import { apiClient } from '@/lib/api/client';
import type { CompanyAccessInfo, RequestLog, LogSearchFilters } from '../types/devtools.types';

export const devtoolsService = {
  async getCompanyAccess(): Promise<CompanyAccessInfo> {
    const response = await apiClient.get('/devtools/company-access');
    return response.data;
  },

  async searchLogs(filters: LogSearchFilters): Promise<RequestLog[]> {
    const response = await apiClient.post('/devtools/logs/search', filters);
    return response.data?.logs || [];
  },
};
